module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-prologue element-with-heading",
    attrs: {
      "epub:type": "prologue",
      "id": "prologue",
      "role": "doc-prologue"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("PROLOGUE")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "prologue-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width first-with-first-letter-i"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("I")]), _vm._v(" didn’t want him to be cold, so I tucked his jacket in around him. It was his favourite; one that I’d bought him for Christmas – or his birthday, I forget. I hadn’t noticed when I saw him earlier in the night, that that’s what he was wearing. It was such a happy memory, though, when I did realise, because he’d wanted the jacket for ages. It was stupidly expensive, and I hadn’t even liked it that much when he pointed it out, two months before – so it must have been Christmas when I bought it, because I remember saving money through October and part of November to make sure I could get it. And – and I hadn’t even liked it. Still, I tucked it in around him, because I didn’t want him to be cold. But more than anything, I just didn’t want him to be dead.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-443afbb9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prologue.vue
// module id = 75
// module chunks = 0